module.exports = __webpack_public_path__ + "images/Deals_Overview_nofp_bg.gif";